export default __webpack_public_path__ + "static/media/bg.5259aee4.jpg";